import {Loc} from '../models/Loc';

//export const UPDATE_LOC = 'UPDATE_LOC';
export const SET_LOC = 'SET_LOC';
//export const GET_CURR_LOC = 'GET_CURR_LOC';

export interface SetLocActions {
  type: typeof SET_LOC;
  payload: Loc;
}

// export interface UpdateLocActions {
//   type: typeof UPDATE_LOC;
//   payload: Loc | null;
// }

// export interface GetCurrLocActions {
//   type: typeof GET_CURR_LOC;
//   payload: Loc | null;
// }

export type CurrLocActions =
  | SetLocActions;
  // | UpdateLocActions
  // | GetCurrLocActions;
